export const SET_USERS_DATA = 'SET_USERS_DATA';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_PAGINATION = 'SET_PAGINATION';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_LIMIT = 'SET_LIMIT';
